import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var PlusIcon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5h7M5 8.5v-7",
    stroke: "#16CA92",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }));
});
PlusIcon.displayName = 'PlusIcon';

export { PlusIcon, PlusIcon as default };
